<template>
	<div class="full page_container">
		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="线下单开票" v-if="findChildren(185)!==-1" name="unserlineorder" style="height: 100%;">
				<unserlineorder-index />
			</el-tab-pane>
			<el-tab-pane label="权益开票" v-if="findChildren(190)!==-1" name="equity" style="height: 100%;">
				<equity-index />
			</el-tab-pane>
		</el-tabs>


	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import unserlineorderIndex from './list/unserlineorder/index.vue'
	import equityIndex from './list/equity/index.vue'
	export default {
		props: {

		},
		data() {
			return {
				activeName: '',
				activeIndex: '',
				departmentChildren: [],

			}
		},
		watch: {

		},
		created() {
			this.departmentChildren = this.$router.currentRoute.meta.children
			if (this.departmentChildren.length != 0) {
				// this.activeName = this.departmentChildren[0].controller
				this.activeName = 'unserlineorder'
			}
			//console.log(this.departmentChildren)
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			findChildren(id) {
				return this.departmentChildren.findIndex((item) => {
					return item.id == id
				})
			},
		},
		components: {
			unserlineorderIndex,
			equityIndex
		}
	}
</script>